import { useEffect, useState } from 'react';

import classNames from 'classnames';

import DiamondIcon from '@/material-icons/400-24px/diamond-fill.svg?react';
import { apiRequestGet } from 'mastodon/api';

// Promotes Nofilter Premium. Clicking sends the user to the subscription
// settings page, where the card and crypto routes are presented side by side
// and they choose one — rather than committing them to a card checkout before
// they have seen that a choice exists. Hides itself for users who already have
// Premium. Rendered directly below the DonationBanner.
export const PremiumBanner: React.FC<{ variant?: 'wide' | 'compact' }> = ({
  variant = 'wide',
}) => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let cancelled = false;
    apiRequestGet<{ active: boolean }>('v1/premium')
      .then((res) => {
        if (cancelled) return;
        if (res.active) setHidden(true);
      })
      .catch(() => {
        // Best-effort: if the status check fails, keep showing the banner.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (hidden) return null;

  return (
    <a
      href='/settings/subscription'
      className={classNames('premium-banner', `premium-banner--${variant}`)}
    >
      <span className='premium-banner__icon' aria-hidden='true'>
        <DiamondIcon />
      </span>
      <span className='premium-banner__text'>
        <span className='premium-banner__title'>Nofilter Premium</span>
        <span className='premium-banner__subtitle'>
          Unlock premium features &amp; support the platform
        </span>
      </span>
      <span className='premium-banner__cta' aria-hidden='true'>
        Upgrade →
      </span>
    </a>
  );
};
